<div class="formatted-budget-value" [ngClass]="{
  'is-overspend': config?.isOverspend,
  'is-bold': config?.isBold,
  'is-label': config?.label != null
}">
  <span class="currency" *ngIf="config?.currencySymbol">{{ config?.currencySymbol }}&nbsp;</span>
  <span class="value" [class.brackets]="config?.withBrackets">{{ displayValue }}</span>
  <span *ngIf="config?.ending" class="bracket">{{ config?.ending }}</span>
</div>
